import * as React from 'react';
import { IStackTokens, Stack } from '@fluentui/react/lib/Stack';
import { Dropdown, DropdownMenuItemType, IDropdownStyles, IDropdownOption } from '@fluentui/react/lib/Dropdown';
import { useEffect, useState, useRef } from "react";
import { Toggle } from '@fluentui/react/lib/Toggle';

const FistComeSelection = (props) => {
    const { setFirstComeFirstServe, isFirstCome } = props;
    const [isEnabled, setIsEnabled] = useState(false);


      async function onFirstComeChange(event) {
        if(isFirstCome) {
            await setFirstComeFirstServe(false);
        }
        else {
            await setFirstComeFirstServe(true);
        }
    }


    return (
        <Stack style={{marginTop: '0.5vh'}}>
            <Toggle label="First come first served" checked={isFirstCome} onText="Enabled" offText="Disabled" onChange={onFirstComeChange} />
        </Stack>
    );
};

export default FistComeSelection;
